<!-- Dati Generali -->
<mat-card class="align-items-center" *ngIf="profileData">
  <div class="image-container">
    <img
      [src]="profilePic"
      class="avatar image bg-white mt-3 rounded-circle"
      id="profileImage" />
    <div class="middle icon-hover">
      <label for="imageUpload" (click)="imageUpload.click()">
        <button mat-mini-fab aria-label="Modifica immagine profilo">
          <mat-icon>edit</mat-icon>
        </button>
      </label>
      <input
        id="imageUpload"
        #imageUpload
        (change)="fileChangeEvent($event)"
        type="file"
        accept="image/png, image/jpeg"
        hidden />
    </div>
  </div>
  <mat-card-header class="text-center pb-3">
    <mat-card-title>{{ profileName + ' ' + profileSurname }}</mat-card-title>
    <mat-card-subtitle>
      <span class="main-font">{{
        profileData.assignmentroles[0]?.alias
          ? profileData.assignmentroles[0]?.alias
          : 'Nessuna'
      }}</span>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content class="align-self-start col-12">
    <mat-list class="pb-4">
      <mat-list-item class="px-0">
        <span matListItemTitle class="main-font">Ruolo</span>
        <span [ngSwitch]="this.roles" matListItemLine>
          <span class="main-font" *ngSwitchCase="'admin'">Admin</span>
          <span class="main-font" *ngSwitchCase="'team_leader'"
            >Team Leader</span
          >
          <span class="main-font" *ngSwitchCase="'project_manager'"
            >Project Manager</span
          >
          <span class="main-font" *ngSwitchDefault>Utente</span>
        </span>
      </mat-list-item>
      <!--             <span matListItemLine class="main-font">Area di competenza</span>
            <span matListItemTitle class="main-font" >{{profileData.assignmentroles[0]?.alias ? profileData.assignmentroles[0]?.alias : "Nessuna"}}</span> -->
      <mat-list-item class="px-0">
        <span matListItemTitle class="main-font">Data di assunzione</span>
        <span matListItemLine class="main-font">{{
          profileData.hiring_date | date: 'dd-MM-YYYY'
        }}</span>
      </mat-list-item>
      <mat-list-item class="px-0">
        <span matListItemTitle class="main-font">Email</span>
        <span
          matListItemLine
          class="main-font"
          [matTooltipDisabled]="profileEmail?.length <= 20"
          [matTooltip]="profileEmail"
          #tooltip="matTooltip"
          (click)="tooltip.show()"
          >{{
            profileEmail?.length <= 25
              ? profileEmail
              : profileEmail.slice(0, 25) + '...'
          }}</span
        >
      </mat-list-item>
      <!--             <span matListItemTitle class="small main-font" >Password</span>
            <span matListItemLine>***********</span>
            <mat-icon class="ms-2 hover-pointer" (click)="editPassword()">edit</mat-icon> -->
    </mat-list>
    <button
      mat-raised-button
      color="accent"
      class="col-12 psw-button"
      (click)="editPassword()">
      Modifica Password
    </button>
  </mat-card-content>
</mat-card>
